import { Select } from "antd";

const paymentTypes = [
    { value: '', label: 'Select Payment Type', disabled: true },
    { value: 'self', label: 'Self' },
    { value: 'ctb', label: 'Commission To Broker' },
    { value: 'nct', label: 'Non-Commissionable Transaction' },
    { value: 'free', label: 'Free of cost' },
    { value: 'referred', label: 'Referred' }
];

const PaymentTypeSelect = ({ 
  value, onChange, disabledItems = [],
  placeholder = "Select Super Group", ...props 
}) => {
  return (
    <Select
      showSearch
      defaultValue={null}
      value={value}
      onChange={(val) => {
        if (onChange) onChange(val);
      }}
      placeholder={placeholder}
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      {...props}
    >
      { paymentTypes
        .map((paymentType) => {
            return { ...paymentType, disabled: paymentType.disabled || disabledItems.includes(paymentType.value.toLowerCase()) };
        })
        .map((paymentType) => (
        <Select.Option key={paymentType.value} value={paymentType.value} disabled={paymentType.disabled || false}>
          {paymentType.label}
        </Select.Option>
      ))}
    </Select>
  );
};


export default PaymentTypeSelect;